var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckroomBlack24Dp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6132_2656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 18.2L13 11.75V10.84C14.65 10.35 15.8 8.66997 15.43 6.78997C15.17 5.47997 14.13 4.38997 12.82 4.08997C10.54 3.56997 8.50002 5.29997 8.50002 7.49997H10.5C10.5 6.66997 11.17 5.99997 12 5.99997C12.83 5.99997 13.5 6.66997 13.5 7.49997C13.5 8.33997 12.81 9.01997 11.97 8.99997C11.43 8.98997 11 9.44997 11 9.98997V11.75L2.40002 18.2C1.63002 18.78 2.04002 20 3.00002 20H12H21C21.96 20 22.37 18.78 21.6 18.2ZM6.00002 18L12 13.5L18 18H6.00002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6132_2656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckroomBlack24Dp1);
export default __webpack_public_path__ + "static/media/checkroom_black_24dp 1.68a3f3030fc3f340828298da5cea1e51.svg";
export { ForwardRef as ReactComponent };